import type {FC, PropsWithChildren} from 'react'
import {FormWrapper, type FormProps} from './form'
import {TextareaField} from './form-elements/textarea-field'
import {ChoiceField} from './form-elements/choice-field'
import {ChoiceGroup} from './form-elements/choice-group'
import {InputField} from './form-elements/input-field'
import {SelectField} from './form-elements/select-field'
import {SearchableSelectField} from './form-elements/searchable-select-field'
import {DateField} from './form-elements/date-field'
import {FieldGroup} from './form-elements/field-group'

interface FormElements {
	InputField: typeof InputField
	SelectField: typeof SelectField
	SearchableSelectField: typeof SearchableSelectField
	ChoiceGroup: typeof ChoiceGroup
	ChoiceField: typeof ChoiceField
	TextareaField: typeof TextareaField
	DateField: typeof DateField
	FieldGroup: typeof FieldGroup
}

type FormWithElements = FC<PropsWithChildren<FormProps>> & FormElements

// @ts-expect-error throws type error relating to FormElements not optional
export const Form: FormWithElements = FormWrapper

Form.InputField = InputField
Form.SelectField = SelectField
Form.SearchableSelectField = SearchableSelectField
Form.ChoiceGroup = ChoiceGroup
Form.ChoiceField = ChoiceField
Form.TextareaField = TextareaField
Form.DateField = DateField
Form.FieldGroup = FieldGroup
